import { getOrgTermsContent } from '../../../content/utils.js';

export const BAR_CHART_X_AXIS_TYPES = [
  {
    name: getOrgTermsContent('projects'),
    singular: getOrgTermsContent('project'),
    value: 'projects',
    excludedDatasetTypes: [0, 6, 7, 9, 10],
  },
  {
    name: 'Stakeholders',
    singular: 'Stakeholder',
    value: 'stakeholders',
    excludedDatasetTypes: [1, 2, 5, 8],
  },
  {
    name: 'Groups',
    singular: 'Group',
    value: 'groups',
    excludedDatasetTypes: [1, 2, 5, 8],
  },
  {
    name: getOrgTermsContent('initiativeTypes'),
    singular: getOrgTermsContent('initiativeType'),
    value: 'initiative_types',
    excludedDatasetTypes: [3, 4, 8],
  },
  {
    name: getOrgTermsContent('initiativeCategories'),
    singular: getOrgTermsContent('initiativeCategory'),
    value: 'initiative_categories',
    excludedDatasetTypes: [4, 8],
  },
  {
    name: 'Employees',
    singular: 'Employee',
    value: 'employees',
    excludedDatasetTypes: [1, 2, 5, 8],
  },
  {
    name: 'Statuses',
    singular: 'Status',
    value: 'statuses',
    excludedDatasetTypes: [6],
  },
  {
    name: 'Archived',
    singular: 'Archived',
    value: 'archived',
    excludedDatasetTypes: [7],
  },
  {
    name: 'Owners',
    singular: 'Owner',
    value: 'owners',
    excludedDatasetTypes: [1, 2, 3, 4, 5, 8, 12],
  },
  {
    name: getOrgTermsContent('projectScopes'),
    singular: getOrgTermsContent('projectScope'),
    value: 'project_scopes',
    excludedDatasetTypes: [9],
  },
  {
    name: getOrgTermsContent('projectImpacts'),
    singular: getOrgTermsContent('projectImpact'),
    value: 'project_impacts',
    excludedDatasetTypes: [10],
  },
  {
    name: getOrgTermsContent('initiativeImpacts'),
    singular: getOrgTermsContent('initiativeImpact'),
    value: 'initiative_impacts',
    excludedDatasetTypes: [11],
  },
];

export const BAR_CHART_DATASET_TYPES = [
  {
    name: getOrgTermsContent('projects'),
    singular: getOrgTermsContent('project'),
    value: 'projects',
  }, // 0
  { name: 'Stakeholders', singular: 'Stakeholder', value: 'stakeholders' }, // 1
  { name: 'Groups', singular: 'Group', value: 'groups' }, // 2
  {
    name: getOrgTermsContent('initiativeTypes'),
    singular: getOrgTermsContent('initiativeType'),
    value: 'initiative_types',
  }, // 3
  {
    name: getOrgTermsContent('initiativeCategories'),
    singular: getOrgTermsContent('initiativeCategory'),
    value: 'initiative_categories',
  }, // 4
  { name: 'Employees', singular: 'Employee', value: 'employees' }, // 5
  { name: 'Statuses', singular: 'Status', value: 'statuses' }, // 6
  { name: 'Archived', singular: 'Archived', value: 'archived' }, // 7
  { name: 'Owners', singular: 'Owner', value: 'owners' }, // 8
  {
    name: getOrgTermsContent('projectScopes'),
    singular: getOrgTermsContent('projectScope'),
    value: 'project_scopes',
  }, // 9
  {
    name: getOrgTermsContent('projectImpacts'),
    singular: getOrgTermsContent('projectImpact'),
    value: 'project_impacts',
  }, // 10
  {
    name: getOrgTermsContent('initiativeImpacts'),
    singular: getOrgTermsContent('initiativeImpact'),
    value: 'initiative_impacts',
  }, // 11
  { name: 'Feedback forms', singular: 'Feedback form', value: 'surveys' }, // 12
];

const createAvailableOptionsX = () => {
  const options = {};

  BAR_CHART_X_AXIS_TYPES.forEach((xAxisType) => {
    const excludedIndices = new Set(xAxisType.excludedDatasetTypes);
    const xAxisValue = xAxisType.value;

    options[xAxisValue] = BAR_CHART_DATASET_TYPES.filter(
      (datasetType, index) => !excludedIndices.has(index)
    );
  });

  return options;
};

export const availableOptionsX = createAvailableOptionsX();
